import { getCsrfToken } from '../auth/authApi'
import type { CapacitySnapshot } from './types'
import { getDeletionAvailability } from '../../shared/deletion/deletionApi'
import { apiFetch } from '../../shared/http/apiFetch'

const baseUrl = '/api/v1/capacity'

export async function getCapacity(options?:{section?:string;query?:string;status?:string;page?:number;pageSize?:number}): Promise<CapacitySnapshot> {
  const parameters=new URLSearchParams()
  if(options)Object.entries(options).forEach(([key,value])=>{if(value!==undefined&&value!=='')parameters.set(key,String(value))})
  const response = await apiFetch(`${baseUrl}${parameters.size?`?${parameters}`:''}`, { credentials: 'include' })
  if (!response.ok) {
    const payload = await response.json().catch(() => null) as { code?: string } | null
    throw new Error(payload?.code ?? 'capacity.loadError')
  }
  return response.json() as Promise<CapacitySnapshot>
}

export async function capacityCommand(
  path: string,
  method: 'POST' | 'PUT' | 'DELETE',
  body?: unknown,
): Promise<{code:string;planningScenarioRequired:boolean}> {
  const response = await apiFetch(`${baseUrl}${path}`, {
    method,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': await getCsrfToken(),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  })
  const payload = await response.json().catch(() => null) as {
    code?: string; planningScenarioRequired?: boolean
  } | null
  if (!response.ok) throw new Error(payload?.code ?? 'capacity.actionError')
  return {code:payload?.code ?? 'capacity.actionCompleted',
    planningScenarioRequired:payload?.planningScenarioRequired ?? false}
}

export const getCapacityDeletionAvailability = (path: string) =>
  getDeletionAvailability(`${baseUrl}${path}`)
